export default "__VITE_ASSET__bb895e75__"